import { pluginFactory } from '@atlaskit/editor-common/utils';
import type {
	EditorState,
	ReadonlyTransaction,
	SafeStateField,
	Transaction,
} from '@atlaskit/editor-prosemirror/state';

import { aiAuditLogsPluginKey } from './ai-audit-log-plugin-key';
import { MAX_RETIRES, RETRY_DELAY } from './constants';
import { reducer } from './reducer';
// eslint-disable-next-line import/order
import type {
	AuditLogEventData,
	AIAuditLogPluginState,
	AIAuditLogUpdatePluginState,
} from './types';
// eslint-disable-next-line import/order
import type { Dispatch } from '@atlaskit/editor-common/event-dispatcher';
// eslint-disable-next-line import/order
import type { Command } from '@atlaskit/editor-common/types';

function onDocChanged(
	tr: ReadonlyTransaction,
	pluginState: AIAuditLogPluginState,
): AIAuditLogPluginState {
	const eventState = pluginState['ai-generated-content-inserted'];

	if (eventState.eventStatus === 'not-sent' && tr.getMeta('isAiContentTransformation')) {
		return {
			...pluginState,
			'ai-generated-content-inserted': {
				...eventState,
				eventStatus: 'send-event',
			},
		};
	}

	return pluginState;
}

export const createInitialState =
	(eventData: AuditLogEventData) =>
	(_state: EditorState): AIAuditLogPluginState => {
		return {
			'ai-generated-content-inserted': {
				eventStatus: 'not-sent',
				retries: 0,
			},
			'aup-violation': {
				eventStatus: 'not-sent',
				retries: 0,
			},
			maxRetries: MAX_RETIRES,
			retryDelay: RETRY_DELAY,
			eventData,
		};
	};

const dest = pluginFactory(aiAuditLogsPluginKey, reducer, {
	onDocChanged,
});
export const createPluginState: (
	dispatch: Dispatch,
	initialState: AIAuditLogPluginState | ((state: EditorState) => AIAuditLogPluginState),
) => SafeStateField<AIAuditLogPluginState> = dest.createPluginState;
export const createCommand: <A = AIAuditLogUpdatePluginState>(
	action: A | ((state: Readonly<EditorState>) => false | A),
	transform?: (tr: Transaction, state: EditorState) => Transaction,
) => Command = dest.createCommand;
export const getPluginState: (state: EditorState) => AIAuditLogPluginState = dest.getPluginState;
